import { Page } from '@/core/architecture'

import { MyOwnedTicketsTemplate } from '../MyOwnedTickets/template'
import { useViewModel } from './viewModel'

/**
 * MyOwnedTickets Page
 * Implemented as a practical sample.
 */
export const MyOwnedTicketsHistory: Page = () => {
  const { state, actions } = useViewModel()

  return <MyOwnedTicketsTemplate state={state} {...actions} />
}
